import React from 'react';
import {Route, Routes} from 'react-router-dom'

import Login from './Login';
import TokenLogin from './TokenLogin';

const _ = () => {
    return (
        <Routes>
            <Route index element={<Login/>}/>
            <Route path=":token" element={<TokenLogin/>}/>
        </Routes>
    );
};

export default _;